import template from './categories.html';
import controller from './categories.controller';

let categoriesComponent = {
  bindings: {},
  template,
  controller
};

export default categoriesComponent;



// WEBPACK FOOTER //
// ./client/app/components/categories-faq/categories.component.js